const proyecto = {
  createProyecto: 'proyecto',
  createProyectoClonar: 'proyecto/{{uuid_proyecto}}/clonar',
  deleteProyecto: 'proyecto/{{uuid_proyecto}}',
  readProyecto: 'proyecto/{{uuid_proyecto}}',
  readProyectoCategorias: 'proyecto/categoria',
  readProyectos: 'proyectos',
  readProyectosByAcademia: 'academia/{{uuid_academia}}/proyectos',
  updateProyecto: 'proyecto/{{uuid_proyecto}}'
}

export default proyecto
